module.exports = __webpack_public_path__ + "static/assets/0fd9fd69a38ab79358df5a77b29702c8.svg";